import ResourceApi from '../ResourceApi';

const SquadResource = {
  all: async (params = {}) => (await ResourceApi.get('/resource/squads', params)).data,
  get: async (id) => (await ResourceApi.get(`/resource/squads/${id}`)).data,
  autocomplete: async (q) => (await ResourceApi.get('/resource/squads', { q })).data,
};

export default SquadResource;
